document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.facets__column-swich svg').forEach((item) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('not-active')) {
        document.querySelectorAll('.facets__column-swich svg').forEach((item) => {
          item.classList.toggle('not-active');
        })

        var grid = document.querySelector('#product-grid');
        if (item.classList.contains('2line')) {
          grid.classList.remove('product-grid__many');
          grid.classList.add('product-grid__fewer');
        } else if (item.classList.contains('3line')) {
          grid.classList.remove('product-grid__fewer');
          grid.classList.add('product-grid__many');
        }
      }
    });
  });
});